/**
 * Cross-tab navigation for the Supernova ↔ Strategy Automation links.
 *
 * The app shell (FinancialDashboard.js) is HUMAN-ONLY and already listens for a
 * DOM event so a component anywhere in the tree can move the member to another
 * tab without a callback threaded through five layers of props:
 *
 *   window.dispatchEvent(new CustomEvent('arc:navigate', { detail: { tab } }))
 *
 * That listener is the ONLY thing these helpers use. Nothing here edits the
 * shell, and nothing here knows about routing, auth, or membership.
 *
 * SHELL WIRING THIS DEPENDS ON (human step, one time):
 *   'strategyautomation' is already a registered tab id — that link works today.
 *   'supernova' is NOT registered yet: the shell's TABS array and its
 *   renderActiveTab switch both live in FinancialDashboard.js, which no agent
 *   may edit. The proposed diff ships as patches/financialDashboard-supernova-tab.patch
 *   for a human to review and apply. Until it is applied, links to the Supernova
 *   tab are only reachable in a build where SUPERNOVA_TAB_ENABLED is on — and
 *   every caller here is already behind that flag, so with the flag off (the
 *   default, and every production build) not one of these links renders.
 */

export const SUPERNOVA_TAB_ID = "supernova";
export const STRATEGY_AUTOMATION_TAB_ID = "strategyautomation";

/** Ask the shell to switch tabs. A no-op anywhere there is no window. */
export function navigateToTab(tab) {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") return;
  window.dispatchEvent(new CustomEvent("arc:navigate", { detail: { tab } }));
}

export const goToSupernovaTab = () => navigateToTab(SUPERNOVA_TAB_ID);
export const goToStrategyAutomationTab = () => navigateToTab(STRATEGY_AUTOMATION_TAB_ID);
